/**
 * this is the main entry point as defined in the package.json
 *
 * 1. it provides the REDUX store to all child components
 * 2. it provides the ROUTER for all child components
 *
 * Created by Tom on 23/5/17
 */

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'

import store, { history } from './store'
import './assets/css/main.scss'
import MemberArea from './components/MemberArea/'
import registerServiceWorker from './registerServiceWorker'

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <MemberArea />
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js